import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-validation-errors-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="modal-overlay" (click)="onClose()">
      <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <div class="modal-icon warning-icon">
            <mat-icon aria-hidden="true">warning</mat-icon>
          </div>
          <h3 class="modal-title">{{ title }}</h3>
        </div>
        <div class="modal-body">
          <p class="intro-text">{{ message }}</p>
          <ul class="error-list">
            @for (error of errors; track error) {
              <li>
                <mat-icon class="li-icon">error_outline</mat-icon>
                <span>{{ error }}</span>
              </li>
            }
          </ul>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" (click)="onClose()">D'accord</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1100;
      backdrop-filter: blur(2px);
    }
    .modal-container {
      background: white;
      border-radius: 12px;
      width: 100%;
      max-width: 450px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      overflow: hidden;
      animation: modalFadeIn 0.2s ease-out;
    }
    @keyframes modalFadeIn {
      from { opacity: 0; transform: scale(0.95); }
      to { opacity: 1; transform: scale(1); }
    }
    .modal-header {
      padding: 1.5rem 1.5rem 0.5rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    .modal-icon {
      font-size: 3rem;
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }
    .warning-icon {
      color: #f59e0b;
    }
    .modal-title {
      margin: 0;
      font-size: 1.25rem;
      font-weight: 700;
      color: #1a237e;
    }
    .modal-body {
      padding: 1rem 1.5rem;
      color: #4b5563;
    }
    .intro-text {
      margin-bottom: 1rem;
      font-weight: 500;
    }
    .error-list {
      list-style: none;
      padding: 0;
      margin: 0;
      max-height: 250px;
      overflow-y: auto;
      text-align: left;
    }
    .error-list li {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding: 0.5rem 0;
      border-bottom: 1px solid #f3f4f6;
    }
    .error-list li:last-child {
      border-bottom: none;
    }
    .li-icon {
      color: #ef4444;
      font-size: 1.25rem;
      width: 1.25rem;
      height: 1.25rem;
    }
    .modal-footer {
      padding: 1.5rem;
      display: flex;
      justify-content: center;
      background-color: #fcfcfd;
    }
    .btn {
      padding: 0.6rem 2rem;
      border-radius: 6px;
      font-weight: 600;
      cursor: pointer;
      border: none;
      transition: all 0.2s;
      font-size: 0.95rem;
    }
    .btn-primary {
      background-color: #1a237e;
      color: white;
    }
    .btn-primary:hover {
      background-color: #0d124b;
      box-shadow: 0 4px 6px rgba(26, 35, 126, 0.2);
    }
  `]
})
export class ValidationErrorsDialogComponent {
  @Input() title: string = 'Éléments non remplis';
  @Input() message: string = 'Veuillez renseigner tous les éléments et les commentaires obligatoires de la FAT pour les catégories suivantes :';
  @Input() errors: string[] = [];

  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
